import React from "react";
import { Image, Text, TextInput, View, TouchableOpacity } from "react-native";
import { AppFontStyle } from "../../../styles/AppFontStyle";
import { AppColors } from "../../../utility/AppColors";
import { CommonButton } from "../../../common/CommonButton";
import { AppImages } from "../../../utility/AppImages";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";

type DateTimeComponentProps = {
  index?: number;
  styles?: any;
  title?: string;
  setShowDatePicker?: (value: boolean) => void;
  setSelectDate?: (date: string) => void;
  selectDate?: string;
  selectTime?: string;
  setSelectTime?: (time: string) => void;
  isOrganiserId?: boolean;
  type?: string;
  dateTitle?: string;
  timeTitle?: string;
  textColor?: any;
  titleFontSize?: any;
};

const DateTimeComponent: React.FC<DateTimeComponentProps> = ({
  styles,
  title = "date and time",
  setShowDatePicker,
  setSelectDate,
  selectDate,
  selectTime,
  setSelectTime,
  isOrganiserId = false,
  type = "schedule",
  dateTitle = "date",
  timeTitle = "time",
  textColor = AppColors.gray_C3C3C3,
  titleFontSize = AppFontStyle.REGULAR_ANYBODY_12,
}) => {
  const deviceSize = useDeviceSize();
  return (
    <>
      {title && (
        <Text style={[AppFontStyle.REGULAR_ANYBODY_14, { marginTop: 10 }]}>
          {title}
        </Text>
      )}
      <View
        style={[
          styles.deviceflexDirection,
          deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE
            ? { columnGap: 25 }
            : { justifyContent: "space-between" },
          { flex: 1 },
        ]}
      >
        <View style={styles.viewStyle}>
          <Text
            style={[
              titleFontSize,
              { marginTop: 10, color: textColor, marginBottom: 10 },
            ]}
          >
            {dateTitle}
          </Text>

          <TouchableOpacity
            style={[styles.inputWrapper]}
            onPress={() => {
              type === "schedule" && isOrganiserId
                ? setShowDatePicker(true)
                : setShowDatePicker(true);
            }}
            activeOpacity={0.9}
          >
            <Image
              source={AppImages.icDateCalendar}
              style={{
                height: 22,
                width: 22,
                position: "absolute",
                marginVertical: 12,
                right: 16,
              }}
            />

            <TextInput
              placeholder={""}
              multiline={false}
              placeholderTextColor={AppColors.gray_C3C3C3}
              style={[AppFontStyle.REGULAR_ANYBODY_14, styles.textInputStyle]}
              editable={false}
              // ref={refValue}
              onSubmitEditing={() => {}}
              onChangeText={setSelectDate}
              keyboardType="default"
              secureTextEntry={false}
              value={selectDate}
            />
          </TouchableOpacity>
        </View>
        <View style={styles.viewStyle}>
          <Text
            style={[
              titleFontSize,
              { marginTop: 10, color: textColor, marginBottom: 10 },
            ]}
          >
            {timeTitle}
          </Text>

          <TouchableOpacity
            style={[styles.inputWrapper]}
            onPress={() => {
              type === "schedule" && isOrganiserId
                ? setShowDatePicker(true)
                : setShowDatePicker(true);
            }}
            activeOpacity={0.9}
          >
            <Image
              source={AppImages.icTopDownArrow}
              style={{
                height: 35,
                width: 20,
                top: 4,
                position: "absolute",
                // marginVertical: 12,
                right: 15,
                resizeMode: "center",
              }}
            />
            <TextInput
              placeholder={""}
              multiline={false}
              placeholderTextColor={AppColors.gray_C3C3C3}
              style={[AppFontStyle.REGULAR_ANYBODY_14, styles.textInputStyle]}
              editable={false}
              // ref={refValue}
              onSubmitEditing={() => {}}
              onChangeText={setSelectTime}
              keyboardType="default"
              secureTextEntry={false}
              value={selectTime}
            />
          </TouchableOpacity>
        </View>
      </View>
    </>
  );
};

export default DateTimeComponent;
